import { FilterValueBase } from "abweb/dto/generated/inputargs/FilterValueBase";
export class FilterValue extends FilterValueBase {}
//# sourceMappingURL=FilterValue.js.map
